import { SlideComponentHkcsQ2 } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentHkcsQ2Creator extends SlideComponentCreator {
    public create(id: string): SlideComponentHkcsQ2 {
        return {
            id: id,
            type: 'hkcsQ2',
            pos: {
                x: 0,
                y: 0,
            },
            size: {
                width: 200,
                height: 200,
            },
            content: {
                image: '',
                characterList: [],
                character: 0,
                characterSound: {
                    jyutping: [],
                    pinyin: [],
                },
                phrase: '',
                phraseSound: {
                    jyutping: [],
                    pinyin: [],
                },
                phraseSoundGroup: {
                    jyutping: [],
                    pinyin: [],
                },
                imageURL: '',
                flip: 1,
            },
        };
    }
}
